import { fromJS } from 'immutable';

import { PROGRESS_BAR_END, PROGRESS_BAR_START } from './constants';

// The initial state of the App
const initialState = fromJS({
  loading: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case PROGRESS_BAR_START:
      return state.set('loading', true);
    case PROGRESS_BAR_END:
      return state.set('loading', false);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./app/containers/ProgressBar/reducer.js